import { render, staticRenderFns } from "./MultiPart.vue?vue&type=template&id=249d485d"
import script from "./MultiPart.vue?vue&type=script&lang=js"
export * from "./MultiPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports